import {
    chainWalk,
    checkInactiveOrDeprecatedAsset,
    convertTableJsonToAsset,
    deepCopyObject,
    getAPIGatewayPostRequest,
    getAssetLabelFromMac,
    getNodeId,
    isResponseCode5xx,
    logOperationalMetric,
    preserveAssetConfigAttributes,
    setAliasToRequest
} from "../../../util/Util";
import {
    ACTIVE,
    ALERT_ASSET_STATUS_MESSAGE, ALERT_START_AR_MOCK_TEST, ASSET_CONFIG_ATTRIBUTES,
    ALERT_UPDATE_ASSET_MESSAGE,
    ALERT_UPDATE_ASSET_MESSAGE_FOR_ACTIVE_ASSET, AUTO_RETRIEVER_ASSET_TYPE,
    DEFAULT_VENDOR_ATTRIBUTES, DEPRECATED, ENDPOINT_START_MOCK_TEST_FOR_AR,
    getUpdateAssetMessageAlertWithSite,
    LOADING_STRING, TEN_SECONDS_LOADER_TIMER,
    METRIC_GET_PICK_STATION_RESOURCES, METRIC_UPDATE_PICK_STATION_CONFIG,
    METRIC_GET_PICK_POINT_RESOURCES, METRIC_UPDATE_RETRIEVER_LOCATION_MAPPING,
    NODE_RESOURCE_TYPE, ASRS_MOCK_PICK, ENDPOINT_PUBLISH_COMMAND_TO_THIN_CLIENT, METRIC_PUBLISH_MOCK_PICK_EVENT
} from "../../../util/Constants";
import {
    addAsset,
    getAssetByAssetLabel,
    getAssets,
    setAssetStatus,
    updateAsset,
    updateAssetInPlace
} from "../../../resources/AssetResource";
import {getAPIGatewayDataFromParent} from "../../../handler/ParentDataHandler";
import {getResourcesV2} from "../../../resources/NodeResource";
import HttpStatus from "http-status-codes";


const metricProcessName = "AUTO_RETRIEVER_DEVICE_DETAILS";
const AR_CONFIG_ATTRIBUTES = ASSET_CONFIG_ATTRIBUTES[AUTO_RETRIEVER_ASSET_TYPE];
export function fetchAutoRetrieverDeviceDetails(dispatcher) {
    const request = {
        nodeId: getNodeId(),
        assetType: AUTO_RETRIEVER_ASSET_TYPE
    }
    getAutoRetrieverDeviceDetails(dispatcher, request)
}

export function setAutoRetrieverDeviceDetails(dispatcher, stateValues, showCustomAlert) {
    stateValues.mac = stateValues.mac.toLowerCase();
    const request = convertTableJsonToAsset(stateValues, AUTO_RETRIEVER_ASSET_TYPE, ACTIVE);
    addAutoRetrieverDeviceDetails(dispatcher, request, showCustomAlert)
}

export function updateAutoRetrieverDeviceDetails(dispatcher, stateValues, showCustomAlert) {
    const request = convertTableJsonToAsset(stateValues, AUTO_RETRIEVER_ASSET_TYPE, ACTIVE);
    updateAutoRetrieverAsset(dispatcher, request, showCustomAlert);
}

export function deleteAutoRetrieverDeviceDetails(dispatcher, mac) {
    const request = {
        assetLabel: {
            type: "MAC_ADDRESS",
            value: mac
        },
        assetStatus: DEPRECATED
    }
    setAssetLabelDeprecatedAutoRetrieverDeviceDetails(dispatcher, request)
}

export async function updateAutoRetrieverDeviceMac(dispatcher, stateValues, mac, showCustomAlert) {
    const startTime = Date.now();
    const assetLabel = getAssetLabelFromMac(stateValues.mac.toLowerCase());
    const assetResult = await getAssetByAssetLabel(assetLabel);
    const nodeId = chainWalk(() => assetResult.data.asset.assetDetails.nodeId, null);
    const assetStatus = chainWalk(() => assetResult.data.asset.assetDetails.assetStatus, null);
    if (assetStatus && !checkInactiveOrDeprecatedAsset(assetStatus)) {
        showCustomAlert(getUpdateAssetMessageAlertWithSite(nodeId));
        logOperationalMetric(startTime, metricProcessName, "addAutoRetrieverDeviceDetails", false, false);
    } else {
        deleteAutoRetrieverDeviceDetails(dispatcher, mac);
        setAutoRetrieverDeviceDetails(dispatcher, stateValues, showCustomAlert);
    }
}

export async function startMockTestForAutoRetriever(dispatcher, mac, showCustomAlert) {
    try {
        const requestInput = {
            nodeId: getNodeId(),
            macAddress: mac
        };
        const startTime = Date.now();
        const args = getAPIGatewayPostRequest(requestInput, ENDPOINT_START_MOCK_TEST_FOR_AR);
        const response = await getAPIGatewayDataFromParent(args);
        if (response.status === HttpStatus.OK) {
            logOperationalMetric(startTime, metricProcessName, "startMockTestForAR", true, false);
            setTimeout(() => {
                dispatcher({type: 'LOAD_VIEW', data: {dispatcher: dispatcher}});
            }, TEN_SECONDS_LOADER_TIMER)
        } else {
            const isFault = isResponseCode5xx(response.status)
            logOperationalMetric(startTime, metricProcessName, "startMockTestForAR", false, isFault);
            dispatcher({type: 'LOAD_VIEW', data: {dispatcher: dispatcher}});
            showCustomAlert(ALERT_START_AR_MOCK_TEST);
        }
    } catch (e) {
        console.log(`Mac Address ${mac} start mock test failed `, e);
        showCustomAlert(ALERT_START_AR_MOCK_TEST);
    }
}

/**
 * Asks NDMS to publish a mock PICK execution event for one item of a mock picklist.
 * @param pickDetails {macAddress, itemId, itemType, cluster, picklistId, groupId, pickPoint}
 * @return {Promise<boolean>} true if NDMS accepted the request
 */
export async function publishMockPickEvent(pickDetails) {
    const startTime = Date.now();
    try {
        const requestInput = {
            nodeId: getNodeId(),
            commandType: ASRS_MOCK_PICK,
            commandParams: JSON.stringify(pickDetails)
        };
        const args = getAPIGatewayPostRequest(requestInput, ENDPOINT_PUBLISH_COMMAND_TO_THIN_CLIENT);
        const response = await getAPIGatewayDataFromParent(args);
        const isSuccess = response.status === HttpStatus.OK;
        logOperationalMetric(startTime, metricProcessName, METRIC_PUBLISH_MOCK_PICK_EVENT, isSuccess,
            isResponseCode5xx(response.status));
        return isSuccess;
    } catch (e) {
        logOperationalMetric(startTime, metricProcessName, METRIC_PUBLISH_MOCK_PICK_EVENT, false, true);
        console.error(`Failed to publish mock pick event for item ${pickDetails.itemId}`, e);
        return false;
    }
}

async function addAutoRetrieverDeviceDetails(dispatcher, request, showCustomAlert) {
    const startTime = Date.now();
    await setAliasToRequest(request);
    addAsset(request).then(async result => {
        if (result.status === 200) {
            logOperationalMetric(startTime, metricProcessName, "addAutoRetrieverDeviceDetails", true, false);
        } else {
            // 500 response status can be for any reason. One of those is : asset already exists so trying to update it.
            // UpdateAsset only works on ACTIVE devices so first setting status as ACTIVE.
            const isFault = isResponseCode5xx(result.status)
            const getAssetResult = await getAssetByAssetLabel(request.assetDetails.assetLabel);
            if (!checkInactiveOrDeprecatedAsset(getAssetResult.data.asset.assetDetails.assetStatus)) {
                showCustomAlert(ALERT_UPDATE_ASSET_MESSAGE_FOR_ACTIVE_ASSET);
                logOperationalMetric(startTime, metricProcessName, "addAutoRetrieverDeviceDetails", false, isFault);
                return;
            }
            const responseSetAssetStatus = await setAssetStatus(request.assetDetails.assetLabel, ACTIVE);
            if (responseSetAssetStatus.status !== 200) {
                showCustomAlert(ALERT_ASSET_STATUS_MESSAGE);
                logOperationalMetric(startTime, metricProcessName, "addAutoRetrieverDeviceDetails", false, isFault);
                return;
            }
            const responseUpdateAsset = await updateAsset(request, chainWalk(() => getAssetResult.data.asset.assetDetails.creationTime, null));
            if (responseUpdateAsset.status !== 200) {
                const isFaultInUpdateAsset = isResponseCode5xx(responseUpdateAsset.status)
                showCustomAlert(ALERT_UPDATE_ASSET_MESSAGE);
                logOperationalMetric(startTime, metricProcessName, "addAutoRetrieverDeviceDetails", false, isFaultInUpdateAsset);
                return;
            }
            logOperationalMetric(startTime, metricProcessName, "addAutoRetrieverDeviceDetails", true, false);
        }
        fetchAutoRetrieverDeviceDetails(dispatcher);
    });
}

async function updateAutoRetrieverAsset(dispatcher, request, showCustomAlert) {
    // Set asset to active first
    const setAssetStatusResponse = await setAssetStatus(request.assetDetails.assetLabel, ACTIVE);
    if (setAssetStatusResponse.status !== 200) {
        showCustomAlert(ALERT_ASSET_STATUS_MESSAGE);
        fetchAutoRetrieverDeviceDetails(dispatcher);
        return;
    }
    // Update asset details
    const startTime = Date.now();
    await setAliasToRequest(request);
    const getAssetResult = await getAssetByAssetLabel(request.assetDetails.assetLabel);
    preserveAssetConfigAttributes(request, chainWalk(() => getAssetResult.data.asset, null), AUTO_RETRIEVER_ASSET_TYPE);
    const updateAssetResponse = await updateAsset(request, chainWalk(() => getAssetResult.data.asset.assetDetails.creationTime, null));
    const isSuccess = updateAssetResponse.status === 200;
    const isFault = isResponseCode5xx(updateAssetResponse.status)
    logOperationalMetric(startTime, metricProcessName, "updateAutoRetrieverDeviceDetails", isSuccess, isFault);
    fetchAutoRetrieverDeviceDetails(dispatcher);
}


async function getAutoRetrieverDeviceDetails(dispatcher, request) {
    const model = {
        autoRetrieverDeviceInformation: {},
        testConfig: {},
        macAddressArray: []
    }
    // Fetch static asset details
    await getAutoRetrieverDeviceStaticDetails(dispatcher, model, request);
    // TODO:: Fetch asset status details
}

async function getAutoRetrieverDeviceStaticDetails(dispatcher, model, request) {
    let pageToken = null;
    // do-while loop until we get a valid pageToken
    do {
        const startTime = Date.now();
        const getAssetsResult = await getAssets(request.nodeId, request.assetType, pageToken)
        const isSuccess = getAssetsResult.status === 200;
        const isFault = isResponseCode5xx(getAssetsResult.status)

        // Log operation
        logOperationalMetric(startTime, metricProcessName, "getAutoRetrieverDeviceDetails", isSuccess, isFault);

        if (isSuccess) {
            addAutoRetrieverDeviceStaticDetailsToModel(getAssetsResult, model)
            // modifying pageToken to fetch from the latest get assets' result
            pageToken = getAssetsResult.data.pageToken
        } else {
            dispatcher({type: "RECEIVE_DATA", data: []});
        }
    } while (pageToken);
    dispatcher({type: "RECEIVE_DATA", data: model});
}

const addAutoRetrieverDeviceStaticDetailsToModel = (result, model) => {
    if ("data" in result && "assetDetailsList" in result.data) {
        result.data.assetDetailsList.forEach((deviceDetail) => {
            if (deviceDetail.assetStatus === ACTIVE) {
                model.macAddressArray.push(deviceDetail.assetAttributes.mac)
                const mac = deviceDetail.assetAttributes.mac;
                const id = JSON.parse(deviceDetail.assetAttributes.deviceConfig).id;
                model.autoRetrieverDeviceInformation[mac] = {
                    name: deviceDetail.assetAttributes.name,
                    mac: deviceDetail.assetAttributes.mac,
                    ip: deviceDetail.assetAttributes.ip,
                    id: id,
                    port: deviceDetail.assetAttributes.port,
                    vendorAttributes: deviceDetail.vendorAttributes || DEFAULT_VENDOR_ATTRIBUTES,
                    assetStatus: LOADING_STRING,
                    deviceType: deviceDetail.assetAttributes.deviceType,
                    assetType: deviceDetail.assetType,
                    pickStationConfig: chainWalk(() => JSON.parse(deviceDetail.assetAttributes[AR_CONFIG_ATTRIBUTES.PICK_STATION_CONFIG]), []),
                    retrieverLocationMapping: chainWalk(() => JSON.parse(deviceDetail.assetAttributes[AR_CONFIG_ATTRIBUTES.LOCATION_MAPPING]), []),
                    startTime: chainWalk(() => JSON.parse(deviceDetail.assetAttributes.monitoring).startTime, "0"),
                    endTime: chainWalk(() => JSON.parse(deviceDetail.assetAttributes.monitoring).endTime, "0"),
                    reason: chainWalk(() => JSON.parse(deviceDetail.assetAttributes.monitoring).reason, ""),
                }
                model.testConfig[mac] = chainWalk(() => JSON.parse(deviceDetail.assetAttributes[AR_CONFIG_ATTRIBUTES.TEST_CONFIG]), {})
            }
        });
    }
    return model;
}

async function setAssetLabelDeprecatedAutoRetrieverDeviceDetails(dispatcher, request) {
    const startTime = Date.now();
    setAssetStatus(request.assetLabel, request.assetStatus).then(result => {
        if (result.status === 200) {
            logOperationalMetric(startTime, metricProcessName, "deleteAutoRetrieverDeviceDetails", true, false);
            fetchAutoRetrieverDeviceDetails(dispatcher);
        } else {
            const isFault = isResponseCode5xx(result.status)
            logOperationalMetric(startTime, metricProcessName, "deleteAutoRetrieverDeviceDetails", false, isFault);
            dispatcher({type: "RECEIVE_DATA", data: []});
        }
    });
}

export async function updateAutoRetrieverMonitoringDetails(dispatcher, stateValues, mac){
    // Get existing details
    const getAssetResult = await getAssetByAssetLabel(getAssetLabelFromMac(mac));

    const updatedAsset = updateExistingAssetAttributes(getAssetResult.data.asset, stateValues);
    updateAutoRetrieverMonitoringSchedule(dispatcher, updatedAsset)
}

const updateExistingAssetAttributes = (asset, stateValues) => {
    const updatedAsset = deepCopyObject(asset);
    updatedAsset.assetDetails.assetAttributes.monitoring =
        chainWalk(() => JSON.stringify(stateValues), asset.assetDetails.assetAttributes.monitoring)
    return updatedAsset;
}

async function updateAutoRetrieverMonitoringSchedule(dispatcher, request) {
    // Update asset details
    const startTime = Date.now();
    const getAssetResult = await getAssetByAssetLabel(request.assetDetails.assetLabel);
    const updateAssetInPlaceResponse = await updateAssetInPlace(request,
        chainWalk(() => getAssetResult.data.asset.assetDetails.lastUpdateTime, null));
    const isSuccess = updateAssetInPlaceResponse.status === 200;
    const isFault = isResponseCode5xx(updateAssetInPlaceResponse.status)
    logOperationalMetric(startTime, metricProcessName, "updateAutoRetrieverDeviceDetails", isSuccess, isFault);
    fetchAutoRetrieverDeviceDetails(dispatcher);
}

async function fetchNodeResources(dispatcher, resourceType, metricName, receiveAction) {
    const startTime = Date.now();
    try {
        const result = await getResourcesV2(getNodeId(), resourceType);
        if (result.status === 200) {
            logOperationalMetric(startTime, metricProcessName, metricName, true, false);
            dispatcher({type: receiveAction, data: chainWalk(() => result.data.nodeResources, [])});
        } else {
            const isFault = isResponseCode5xx(result.status);
            logOperationalMetric(startTime, metricProcessName, metricName, false, isFault);
            dispatcher({type: receiveAction, data: []});
        }
    } catch (e) {
        logOperationalMetric(startTime, metricProcessName, metricName, false, true);
        console.error(`Failed to fetch node resources for ${resourceType}`, e);
        dispatcher({type: receiveAction, data: []});
    }
}

export const fetchPickStationResources = (dispatcher) =>
    fetchNodeResources(dispatcher, NODE_RESOURCE_TYPE.PICK_STATION,
        METRIC_GET_PICK_STATION_RESOURCES, "RECEIVE_PICK_STATION_RESOURCES");

export const fetchPickPointResources = (dispatcher) =>
    fetchNodeResources(dispatcher, NODE_RESOURCE_TYPE.PICK_POINT,
        METRIC_GET_PICK_POINT_RESOURCES, "RECEIVE_PICK_POINT_RESOURCES");

export async function updatePickStationConfig(dispatcher, mac, config, showCustomAlert) {
    const startTime = Date.now();
    try {
        const getAssetResult = await getAssetByAssetLabel(getAssetLabelFromMac(mac));
        const updatedAsset = deepCopyObject(getAssetResult.data.asset);
        updatedAsset.assetDetails.assetAttributes[AR_CONFIG_ATTRIBUTES.PICK_STATION_CONFIG] = JSON.stringify(config);

        const updateResponse = await updateAssetInPlace(updatedAsset,
            chainWalk(() => getAssetResult.data.asset.assetDetails.lastUpdateTime, null));
        const isSuccess = updateResponse.status === 200;
        const isFault = isResponseCode5xx(updateResponse.status);
        logOperationalMetric(startTime, metricProcessName, METRIC_UPDATE_PICK_STATION_CONFIG, isSuccess, isFault);

        if (!isSuccess) {
            showCustomAlert(ALERT_UPDATE_ASSET_MESSAGE);
        }
        fetchAutoRetrieverDeviceDetails(dispatcher);
    } catch (e) {
        logOperationalMetric(startTime, metricProcessName, METRIC_UPDATE_PICK_STATION_CONFIG, false, true);
        console.error("Failed to update pick station config", e);
        showCustomAlert(ALERT_UPDATE_ASSET_MESSAGE);
        fetchAutoRetrieverDeviceDetails(dispatcher);
    }
}

export async function updateRetrieverLocationMapping(dispatcher, mac, config, showCustomAlert) {
    const startTime = Date.now();
    try {
        const getAssetResult = await getAssetByAssetLabel(getAssetLabelFromMac(mac));
        const updatedAsset = deepCopyObject(getAssetResult.data.asset);
        updatedAsset.assetDetails.assetAttributes[AR_CONFIG_ATTRIBUTES.LOCATION_MAPPING] = JSON.stringify(config);

        const updateResponse = await updateAssetInPlace(updatedAsset,
            chainWalk(() => getAssetResult.data.asset.assetDetails.lastUpdateTime, null));
        const isSuccess = updateResponse.status === 200;
        const isFault = isResponseCode5xx(updateResponse.status);
        logOperationalMetric(startTime, metricProcessName, METRIC_UPDATE_RETRIEVER_LOCATION_MAPPING, isSuccess, isFault);

        if (!isSuccess) {
            showCustomAlert(ALERT_UPDATE_ASSET_MESSAGE);
        }
        fetchAutoRetrieverDeviceDetails(dispatcher);
    } catch (e) {
        logOperationalMetric(startTime, metricProcessName, METRIC_UPDATE_RETRIEVER_LOCATION_MAPPING, false, true);
        console.error("Failed to update retriever location mapping", e);
        showCustomAlert(ALERT_UPDATE_ASSET_MESSAGE);
        fetchAutoRetrieverDeviceDetails(dispatcher);
    }
}


// WEBPACK FOOTER //
// ./src/components/devicemanagement/autoretriever/network/AutoRetrieverDeviceNetworkAPI.js